import Vue from 'vue'
import Vuex from 'vuex'
import appService from '../appService'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isAuthenticated: false
  },

  mutations: {
    login (state, token) {
      window.localStorage.setItem('token', token.token)
      window.localStorage.setItem('tokenExpiration', token.expiration)
      state.isAuthenticated = true
    },

    logout (state) {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('tokenExpiration')
      state.isAuthenticated = false
    }
  },

  actions: {
    login (context, credentials) {
      return appService.login(credentials)
      .then(data => {
        context.commit('login', data)}
      )
    },

    logout (context) {
      context.commit('logout')
    }
  }
})

function setInitialState() {
  let expiration = window.localStorage.getItem('tokenExpiration')
  const unixTimestamp = new Date().getTime() / 1000
  if (expiration !== null && parseInt(expiration) - unixTimestamp > 0) {
    store.state.isAuthenticated = true
  }
}

setInitialState()

export default store



// WEBPACK FOOTER //
// ./src/store/index.js